<div class="admin-wrapper">

  <div class="admin-sidebar" [class.sidebar-active]="isSidebarVisible">
    <div class="sidebar-brand">
      MOANANI <span class="text-xs font-normal block text-gray-400">ADMIN</span>
    </div>

    <div class="sidebar-menu">

      <a routerLink="/admin/dashboard" routerLinkActive="active" [attr.href]="'/admin/dashboard'" (click)="isSidebarVisible = false">
        <i class="pi pi-th-large mr-2"></i> Dashboard
      </a>

      <div class="menu-dropdown">
        <a class="cursor-pointer flex justify-content-between align-items-center"
           (click)="toggleOrdersMenu()"
           [class.active-parent]="isOrdersMenuOpen">
          <span><i class="pi pi-shopping-bag mr-2"></i> Ventas Manuales</span>
          <i class="pi" [ngClass]="isOrdersMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.8rem"></i>
        </a>

        <div class="submenu" [class.submenu-open]="isOrdersMenuOpen">
          <a routerLink="/admin/orders/new" routerLinkActive="active" [attr.href]="'/admin/orders/new'" (click)="isSidebarVisible = false">
            <i class="pi pi-plus-circle mr-2 text-sm"></i> Nueva Venta
          </a>
          <a routerLink="/admin/orders/active" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" [attr.href]="'/admin/orders/active'" (click)="isSidebarVisible = false">
            <i class="pi pi-truck mr-2 text-sm"></i> Gestion Entregas
          </a>
          <a routerLink="/admin/orders/history" routerLinkActive="active" [attr.href]="'/admin/orders/history'" (click)="isSidebarVisible = false">
            <i class="pi pi-clock mr-2 text-sm"></i> Historial
          </a>
        </div>
      </div>

      <div class="menu-dropdown">
        <a class="cursor-pointer flex justify-content-between align-items-center"
           (click)="toggleWebOrdersMenu()"
           [class.active-parent]="isWebOrdersMenuOpen">
          <span><i class="pi pi-globe mr-2"></i> Ventas Web
            <span *ngIf="newPaidWebOrders > 0" class="ml-2 px-2 border-round-xl bg-red-500 text-white text-xs font-bold">{{ newPaidWebOrders }}</span>
          </span>
          <i class="pi" [ngClass]="isWebOrdersMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.8rem"></i>
        </a>

        <div class="submenu" [class.submenu-open]="isWebOrdersMenuOpen">
          <a routerLink="/admin/web-orders/verify" routerLinkActive="active" [attr.href]="'/admin/web-orders/verify'" (click)="isSidebarVisible = false">
            <i class="pi pi-check-square mr-2 text-sm"></i> Pagos web
          </a>
          <a routerLink="/admin/web-orders/delivery" routerLinkActive="active" [attr.href]="'/admin/web-orders/delivery'" (click)="isSidebarVisible = false; markNewPaidWebOrdersSeen()">
            <i class="pi pi-truck mr-2 text-sm"></i> Gestión Entregas
            <span *ngIf="newPaidWebOrders > 0" class="ml-2 px-2 border-round-xl bg-red-500 text-white text-xs font-bold">{{ newPaidWebOrders }}</span>
          </a>
          <a routerLink="/admin/web-orders/history" routerLinkActive="active" [attr.href]="'/admin/web-orders/history'" (click)="isSidebarVisible = false">
            <i class="pi pi-clock mr-2 text-sm"></i> Historial Web
          </a>
          <a routerLink="/admin/web-orders/finance" routerLinkActive="active" [attr.href]="'/admin/web-orders/finance'" (click)="isSidebarVisible = false">
            <i class="pi pi-chart-line mr-2 text-sm"></i> Finanzas
          </a>
          <a routerLink="/admin/payment-methods" routerLinkActive="active" [attr.href]="'/admin/payment-methods'" (click)="isSidebarVisible = false">
            <i class="pi pi-wallet mr-2 text-sm"></i> Métodos de Pago
          </a>
        </div>
      </div>

      <div class="menu-dropdown">
        <a class="cursor-pointer flex justify-content-between align-items-center"
           (click)="toggleProductsMenu()"
           [class.active-parent]="isProductsMenuOpen">
          <span><i class="pi pi-tag mr-2"></i>Tienda</span>
          <i class="pi" [ngClass]="isProductsMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.8rem"></i>
        </a>

        <div class="submenu" [class.submenu-open]="isProductsMenuOpen">
          <a routerLink="/admin/products" routerLinkActive="active" [attr.href]="'/admin/products'" (click)="isSidebarVisible = false">
            <i class="pi pi-box mr-2 text-sm"></i> Productos
          </a>
          <a routerLink="/admin/stock" routerLinkActive="active" [attr.href]="'/admin/stock'" (click)="isSidebarVisible = false">
            <i class="pi pi-database mr-2 text-sm"></i> Control de Stock
          </a>
          <a routerLink="/admin/categories" routerLinkActive="active" [attr.href]="'/admin/categories'" (click)="isSidebarVisible = false">
            <i class="pi pi-list mr-2 text-sm"></i> Categorías
          </a>
          <a routerLink="/admin/modelos" routerLinkActive="active" [attr.href]="'/admin/modelos'" (click)="isSidebarVisible = false">
            <i class="pi pi-sitemap mr-2 text-sm"></i> Modelos
          </a>
          <a routerLink="/admin/brands" routerLinkActive="active" [attr.href]="'/admin/brands'" (click)="isSidebarVisible = false">
            <i class="pi pi-tag mr-2 text-sm"></i> Marcas
          </a>
          <a routerLink="/admin/sizes" routerLinkActive="active" [attr.href]="'/admin/sizes'" (click)="isSidebarVisible = false">
            <i class="pi pi-sliders-h mr-2 text-sm"></i> Tallas
          </a>
          <a routerLink="/admin/colors" routerLinkActive="active" [attr.href]="'/admin/colors'" (click)="isSidebarVisible = false">
            <i class="pi pi-palette mr-2 text-sm"></i> Colores
          </a>
        </div>
      </div>

      <div class="menu-dropdown">
        <a class="cursor-pointer flex justify-content-between align-items-center"
           (click)="toggleUsersMenu()"
           [class.active-parent]="isUsersMenuOpen">
          <span><i class="pi pi-users mr-2"></i> Gestion Usuarios</span>
          <i class="pi" [ngClass]="isUsersMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.8rem"></i>
        </a>

        <div class="submenu" [class.submenu-open]="isUsersMenuOpen">
          <a routerLink="/admin/users" routerLinkActive="active" [attr.href]="'/admin/users'" (click)="isSidebarVisible = false">
            <i class="pi pi-user-plus mr-2 text-sm"></i> Usuarios admin
          </a>
        </div>
      </div>

      <div class="menu-dropdown">
        <a class="cursor-pointer flex justify-content-between align-items-center"
           (click)="toggleSystemMenu()"
           [class.active-parent]="isSystemMenuOpen">
          <span><i class="pi pi-cog mr-2"></i> Sistema</span>
          <i class="pi" [ngClass]="isSystemMenuOpen ? 'pi-chevron-down' : 'pi-chevron-right'" style="font-size: 0.8rem"></i>
        </a>

        <div class="submenu" [class.submenu-open]="isSystemMenuOpen">
          <a routerLink="/admin/estados" routerLinkActive="active" [attr.href]="'/admin/estados'" (click)="isSidebarVisible = false">
            <i class="pi pi-bookmark mr-2 text-sm"></i> Estados
          </a>
          <a routerLink="/admin/tipo-envio" routerLinkActive="active" [attr.href]="'/admin/tipo-envio'" (click)="isSidebarVisible = false">
            <i class="pi pi-truck mr-2 text-sm"></i> Tipo de Envío
          </a>
          <a routerLink="/admin/origen-venta" routerLinkActive="active" [attr.href]="'/admin/origen-venta'" (click)="isSidebarVisible = false">
            <i class="pi pi-share-alt mr-2 text-sm"></i> Origen de Venta
          </a>
          <a routerLink="/admin/tipo-moneda" routerLinkActive="active" [attr.href]="'/admin/tipo-moneda'" (click)="isSidebarVisible = false">
            <i class="pi pi-wallet mr-2 text-sm"></i> Tipo de Moneda
          </a>
          <a routerLink="/admin/clientes" routerLinkActive="active" [attr.href]="'/admin/clientes'" (click)="isSidebarVisible = false">
            <i class="pi pi-users mr-2 text-sm"></i> Clientes
          </a>
          <a routerLink="/admin/ubigeo" routerLinkActive="active" [attr.href]="'/admin/ubigeo'" (click)="isSidebarVisible = false">
            <i class="pi pi-map mr-2 text-sm"></i> Ubigeo
          </a>
          <a routerLink="/admin/boletas" routerLinkActive="active" [attr.href]="'/admin/boletas'" (click)="isSidebarVisible = false">
            <i class="pi pi-file mr-2 text-sm"></i> Boletas
          </a>
          <a routerLink="/admin/newsletter" routerLinkActive="active" [attr.href]="'/admin/newsletter'" (click)="isSidebarVisible = false">
            <i class="pi pi-envelope mr-2 text-sm"></i> Club / Newsletter
          </a>
          <a routerLink="/admin/audit" routerLinkActive="active" [attr.href]="'/admin/audit'" (click)="isSidebarVisible = false">
            <i class="pi pi-eye mr-2 text-sm"></i> Auditoría
          </a>
        </div>
      </div>

      <div class="divider"></div>

      <a class="logout-btn cursor-pointer" (click)="onLogout()">
        <i class="pi pi-power-off mr-2"></i> Cerrar Sesión
      </a>
    </div>
  </div>

  <div class="sidebar-overlay" [class.active]="isSidebarVisible" (click)="isSidebarVisible = false"></div>

  <div class="admin-content">
    <div class="admin-topbar">
      <button class="menu-btn p-link mr-3" (click)="toggleSidebar()">
        <i class="pi pi-bars text-2xl"></i>
      </button>

      <div class="flex align-items-center gap-3 ml-auto">
        <a routerLink="/" class="shop-link no-underline text-900 font-medium">
          <i class="pi pi-home mr-1"></i> Ver Tienda
        </a>
        <div class="user-info flex align-items-center gap-2">
          <div class="w-2rem h-2rem bg-blue-100 border-circle flex align-items-center justify-content-center">
            <span class="text-blue-700 font-bold">{{ adminName.charAt(0).toUpperCase() }}</span>
          </div>
          <span class="hidden sm:inline font-bold">{{ adminName }}</span>
        </div>
      </div>
    </div>

    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
